import Settings from './Settings';
import Route from './route';

export default { RenderProp: Settings, mainRoute: Route };
